import React, { useState } from "react";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";
import { deleteNotificationForUser, deleteNotificationForAll } from "../../services/NotificationService";
import "./AdminModalForm.css";

// Admin modal for deleting notifications with target selection
const AdminDeleteNotificationModal = ({ isOpen, onClose, notification, onDeleted }) => {
  // State management
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState("user"); // "user" | "all"
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Don't render if modal is closed or no notification
  if (!isOpen || !notification) return null;

  // Execute deletion based on target type
  const executeDeletion = async () => {
    if (target === "all") {
      await deleteNotificationForAll(notification.id);
      setSuccess("Notification deleted for all users.");
    } else {
      await deleteNotificationForUser(notification.id);
      setSuccess("Notification deleted for this user.");
    }
  };

  // Main deletion handler
  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    try {
      setLoading(true);
      await executeDeletion();

      // Auto-close after success
      setTimeout(() => {
        onDeleted?.();
        onClose();
      }, 1000);
    } catch (err) {
      setError(err.message || "Failed to delete notification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={loading ? () => {} : onClose}
      title="Delete Notification"
      actions={
        <>
          <SecondButton onClick={onClose} disabled={loading}>
            Cancel
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </MainButton>
        </>
      }
    >
      {/* Notification deletion confirmation form */}
      <div className="admin-modal-form">
        {/* Confirmation message */}
        <p>
          Are you sure you want to delete this notification?
          <br />
          <strong>{notification.name}</strong>
        </p>

        {/* User information */}
        <p>
          User: <strong>{notification.user_id || "All / multiple users"}</strong>
        </p>

        {/* Warning message */}
        <p>This action cannot be undone.</p>

        {/* Delete target selector */}
        <label>
          Delete target *
          <div className="admin-modal-select-wrapper">
            <select
              name="deleteTarget"
              value={target}
              onChange={(e) => setTarget(e.target.value)}
              disabled={loading}
              className="admin-modal-select admin-modal-select-with-arrow"
            >
              <option value="user">Only for this user</option>
              <option value="all">For all users</option>
            </select>
          </div>
        </label>

        {/* Error message display */}
        {error && (
          <div className="admin-modal-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {/* Success message display */}
        {success && (
          <div className="admin-modal-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AdminDeleteNotificationModal;
